export default {
    /************* 라이브 서버 *************/
    apiRoot: 'https://callcenter-api.bgsoft.kr:8443/', // IDC 관제 라이브
    // apiRoot: 'https://api.logishm.com:8443/', // IDC 메인 라이브

    /************* 라이브 테스트 서버 *************/
    // apiRoot: 'https://live-api.logishm.com:7443/', // IDC 238 테스트
    // apiRoot: 'https://live-api.logishm.com:8443/', // IDC 238 테스트

    /************* 테스트 서버 *************/
    // apiRoot: 'https://test-api.logishm.com:8443/', // 3층 테스트
    // apiRoot: 'https://test-api3.logishm.com:8443/', // IDC 테스트
    // apiRoot: 'http://52.78.59.46:8080/'			// DR 서버

    /************* 로컬서버 *************/
    // apiRoot: 'http://localhost:9090/',
    // apiRoot: 'http://172.30.1.79:9090/',
 
};
